import { render, staticRenderFns } from "./VendaOrcamentoGet.vue?vue&type=template&id=b1eeee38&scoped=true"
import script from "./VendaOrcamentoGet.vue?vue&type=script&lang=js"
export * from "./VendaOrcamentoGet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1eeee38",
  null
  
)

export default component.exports